import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
export var ResizeEvent = /*#__PURE__*/function () {
  function ResizeEvent() {
    _classCallCheck(this, ResizeEvent);

    this.delay = 0.5;
    this.enable = true;
  }

  _createClass(ResizeEvent, [{
    key: "load",
    value: function load(data) {
      if (data === undefined) {
        return;
      }

      if (data.delay !== undefined) {
        this.delay = data.delay;
      }

      if (data.enable !== undefined) {
        this.enable = data.enable;
      }
    }
  }]);

  return ResizeEvent;
}();